import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { get } from "lodash";
import $ from 'jquery-slim';
import Text from "../../../components/Text"
import Spacer from "../../../components/Spacer"
import Button from "../../../components/Field/Button"

import style from "./style.module.css";

const VersionCheck = () => {
    const [visible, setVisible] = useState(false);
    const [animate, setAnimate] = useState(false);
    const newVersion = useSelector(state => get(state, 'storage.version', ''));
    const oldVersionRef = useRef($('meta[name="version"]').attr('content') || "");
    const timerRef = useRef(null);

    useEffect(() => {
        if (oldVersionRef.current && newVersion && oldVersionRef.current !== newVersion) {
            setVisible(true);
        }
        oldVersionRef.current = newVersion;
    }, [newVersion]);

    useEffect(() => {
        if (visible) {
            clearTimeout(timerRef.current);
            timerRef.current = setTimeout(() => setAnimate(true), 10);
        }
        return () => clearTimeout(timerRef.current);
    }, [visible]);

    if (visible === false) {
        return null;
    }

    return (
        <div className={`${style.versionCheck} ${animate ? style.show : ''}`}>
            <div className={style.innerwrap}>
                <Text text="There are some unapplied updates on this website. Click the Refresh button to bring it up to date." />
                <Spacer />
                <Button label="Refresh" onClick={() => { window.location.reload(true); }} />
            </div>
        </div>
    );
}

export default VersionCheck;
